import { LiveBoardTrip, legOf, severityOf } from "map/liveBoard";

/**
 * The board's colours.
 *
 * Carried over from the standalone board unchanged. Three hues do the status work -- blue for
 * pending, green for the two moving legs, amber and red for the two severities -- plus a neutral
 * slate for a returning (empty) van, which is idle rather than interesting. They were picked so
 * that every pair survives a colour-blindness check; a fourth status hue did not, which is why
 * "to pickup" and "to dropoff" share green and are told apart by the mark at the end of the line
 * instead. Magenta and gold are deliberately outside the status scale: magenta only ever means
 * backhaul, gold only ever means hover/selection.
 *
 * These are the light-mode values of the original's two palettes, which is the pair that was
 * validated against a light background -- Flow's chrome and the streets basemap are both light.
 */
export const BOARD_COLORS = {
  pending: "#2a78d6",
  toPickup: "#1baf7a",
  toDropoff: "#1baf7a",
  return: "#5b6570",
  late: "#d03b3b",
  warn: "#c98500",
  backhaul: "#b8289a",
  /** Hover and selection. Used for nothing else on the board. */
  accent: "#c77d00",
  /** The halo that keeps a mark readable over any basemap. */
  ring: "#ffffff",
  hub: "#4d5a66",
};

export const LEG_COLOR: Record<string, string> = {
  pending: BOARD_COLORS.pending,
  to_pickup: BOARD_COLORS.toPickup,
  to_dropoff: BOARD_COLORS.toDropoff,
  return: BOARD_COLORS.return,
};

/** Severity wins over the leg's base colour, on the map and everywhere the trip is written down. */
export const colorFor = (t: LiveBoardTrip): string => {
  const sev = severityOf(t);
  if (sev === "late") return BOARD_COLORS.late;
  if (sev === "warn") return BOARD_COLORS.warn;
  return LEG_COLOR[legOf(t)] || BOARD_COLORS.return;
};

/**
 * Stacking floor for anything drawn OVER the map -- the legend, the zoom/fit controls.
 *
 * Trip Markers set their own z-index (1 normally, 2 while selected), so an overlay left on the
 * default auto value loses the stack and the marks draw straight through it. Well clear of both.
 */
export const OVERLAY_Z = 10;
